/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAddonDto } from '../models/CreateAddonDto';
import type { FetchSubscriptionTransactionsApiResponse } from '../models/FetchSubscriptionTransactionsApiResponse';
import type { LinkPlanDto } from '../models/LinkPlanDto';
import type { SubscriptionTransactionDetailApiResponse } from '../models/SubscriptionTransactionDetailApiResponse';
import type { UpdateAddonDto } from '../models/UpdateAddonDto';
import type { UpdatePlanDto } from '../models/UpdatePlanDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminSubscriptionManagementService {
    /**
     * List subscription & addon transactions
     * Paginated list of expert subscription and addon purchase records. Filter by paymentType (subscription | addon), status (pending | active | expired | cancelled | paused), and date range.
     * @param paymentType Filter by payment type
     * @param statuses Filter by one or more subscription statuses
     * @param search Free text search over transaction number or expert name
     * @param dateFrom Filter transactions on/after this date (ISO 8601)
     * @param dateTo Filter transactions on/before this date (ISO 8601)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchSubscriptionTransactionsApiResponse Subscription transactions fetched successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerFetchSubscriptionTransactionsV1(
        paymentType?: 'subscription' | 'addon',
        statuses?: Array<'pending' | 'active' | 'expired' | 'cancelled' | 'paused'>,
        search?: string,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchSubscriptionTransactionsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/transactions',
            query: {
                'paymentType': paymentType,
                'statuses': statuses,
                'search': search,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get subscription or addon transaction detail
     * Retrieve full detail for an expert subscription or addon purchase by its UUID.
     * @param id expert_subscriptions or expert_addons UUID
     * @returns SubscriptionTransactionDetailApiResponse Detail retrieved successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerGetSubscriptionTransactionDetailV1(
        id: string,
    ): CancelablePromise<SubscriptionTransactionDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/transactions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Record not found`,
            },
        });
    }
    /**
     * Fetch subscription plans
     * List plan configs with product data from RevenueCat (when integrated), subscriber counts, and computed MRR/ARR. Filter by isActive and/or planStatus.
     * @param isActive Filter by admin active toggle (visible in app)
     * @param planStatus Filter by plan lifecycle status
     * @param isMostPopular Filter by most popular flag
     * @returns any Plans fetched successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerFetchPlansV1(
        isActive?: boolean,
        planStatus?: 'active' | 'inactive' | 'grandfathered',
        isMostPopular?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/plans',
            query: {
                'isActive': isActive,
                'planStatus': planStatus,
                'isMostPopular': isMostPopular,
            },
        });
    }
    /**
     * Link subscription plan config
     * Create a plan config linked to a RevenueCat product. Plans themselves are created in App Store Connect / Google Play Console, not in admin.
     * @param requestBody
     * @returns any Plan config linked successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerLinkPlanV1(
        requestBody: LinkPlanDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/subscriptions/plans',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                409: `Config for this RevenueCat product already exists`,
            },
        });
    }
    /**
     * Fetch expert pricing with packages
     * Returns packages for the expert with name, totalSessions, sessionsPerWeek, mode, and single/duo per-mode session prices (online, expert_location, client_location).
     * @param expertId Expert UUID
     * @returns any Expert pricing with packages fetched
     * @throws ApiError
     */
    public static adminSubscriptionsControllerFetchExpertPricingWithPackagesV1(
        expertId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/experts/{expertId}/pricing-packages',
            path: {
                'expertId': expertId,
            },
        });
    }
    /**
     * Get subscription plan detail
     * Retrieve one plan config with merged product data and computed MRR/ARR. Id is the config UUID.
     * @param id Plan config UUID
     * @returns any Plan detail retrieved
     * @throws ApiError
     */
    public static adminSubscriptionsControllerGetPlanDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/plans/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Plan not found`,
            },
        });
    }
    /**
     * Update subscription plan config
     * Update config only: commission %, features, session limits, Most Popular badge, isActive, planStatus. Product name/price/period are read-only (from RevenueCat).
     * @param id Plan config UUID
     * @param requestBody
     * @returns any Plan updated
     * @throws ApiError
     */
    public static adminSubscriptionsControllerUpdatePlanV1(
        id: string,
        requestBody: UpdatePlanDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/subscriptions/plans/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Plan not found`,
            },
        });
    }
    /**
     * Fetch add-ons
     * Retrieve all add-ons with purchase counts and revenue.
     * @param isActive Filter by active/inactive status
     * @param addonType Filter by addon type
     * @returns any Add-ons fetched successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerFetchAddonsV1(
        isActive?: boolean,
        addonType?: 'in_app' | 'offline_marketing',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/addons',
            query: {
                'isActive': isActive,
                'addonType': addonType,
            },
        });
    }
    /**
     * Create add-on
     * Create a new add-on for experts.
     * @param requestBody
     * @returns any Add-on created successfully
     * @throws ApiError
     */
    public static adminSubscriptionsControllerCreateAddonV1(
        requestBody: CreateAddonDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/subscriptions/addons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                409: `Add-on name already exists`,
            },
        });
    }
    /**
     * Get add-on detail
     * Retrieve detailed information about a specific add-on.
     * @param id Add-on UUID
     * @returns any Add-on detail retrieved
     * @throws ApiError
     */
    public static adminSubscriptionsControllerGetAddonDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/subscriptions/addons/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Add-on not found`,
            },
        });
    }
    /**
     * Update add-on
     * Update an add-on. Send { "isActive": false } to deactivate. Deactivating does NOT cancel existing active purchases.
     * @param id Add-on UUID
     * @param requestBody
     * @returns any Add-on updated
     * @throws ApiError
     */
    public static adminSubscriptionsControllerUpdateAddonV1(
        id: string,
        requestBody: UpdateAddonDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/subscriptions/addons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Add-on not found`,
                409: `Add-on name already exists`,
            },
        });
    }
}
